import { ApprovalState, ReportType } from '@fdm/api-client';
import { ReportFormPage } from '../../report-form-control.service';

export const PRODUCTION_OPERATIONS_MANAGER_POLICY = {
  [ReportType.IntegrityDeficiency]: {
    [ReportFormPage.NOTES_ATTACHMENTS]: [
      ApprovalState.Draft,
      ApprovalState.DraftedForReview,
      ApprovalState.SubmittedToOpsAdvisor,
      ApprovalState.PlanConfirmed,
      ApprovalState.PlanEndorsed,
      ApprovalState.PlanApproved,
      ApprovalState.RIPTScored,
      ApprovalState.RiskEvaluationScored,
      ApprovalState.ResolutionPlanCompleted,
      ApprovalState.ValidationAndVerificationCompleted,
    ],
  },
  [ReportType.ReliabilityDeficiency]: {
    [ReportFormPage.NOTES_ATTACHMENTS]: [
      ApprovalState.Draft,
      ApprovalState.DraftedForReview,
      ApprovalState.SubmittedToOpsAdvisor,
      ApprovalState.PlanConfirmed,
      ApprovalState.PlanEndorsed,
      ApprovalState.PlanApproved,
      ApprovalState.RIPTScored,
      ApprovalState.RiskEvaluationScored,
      ApprovalState.ResolutionPlanCompleted,
      ApprovalState.ValidationAndVerificationCompleted,
    ],
  },
  [ReportType.TaskDeferral]: {
    [ReportFormPage.NOTES_ATTACHMENTS]: [
      ApprovalState.Draft,
      ApprovalState.DraftedForReview,
      ApprovalState.SubmittedToOpsAdvisor,
      ApprovalState.PlanConfirmed,
      ApprovalState.PlanEndorsed,
      ApprovalState.PlanApproved,
      ApprovalState.RiskEvaluationScored,
      ApprovalState.ResolutionPlanCompleted,
      ApprovalState.ValidationAndVerificationCompleted,
    ],
  },
};